// export const ENVIRONMENT = 'dev'
export const ENVIRONMENT = 'local'
